/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import swal from 'sweetalert';

export default function AlertDelete (id, postData, confirmacio){

    const bold = document.createElement("b");
    const missatge = document.createElement("p");
    const missatgeConfirmacio = document.createElement("p");

    bold.innerHTML = ` <b> ${id} </b> `;
    missatge.innerHTML = "Segur que vols eliminar el registre:" + bold.innerHTML + " ?";
    missatgeConfirmacio.innerHTML= `Escriu <b>ELIMINAR</b> per confirmar`;

    // DIV en el que contiene tanto el mensaje como el campo de entrada
    const container = document.createElement("div");
    container.appendChild(missatge);
    container.appendChild(missatgeConfirmacio);

    const input = document.createElement("input");
    input.type = "text";
    input.placeholder = "ELIMINAR";
    container.appendChild(input);
  
    // 2. Configurar opciones de la alerta swal
    swal({
        title: "Atenció:",
        content: container, // Le pasamos toddo el contenido
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel·lar", "Eliminar"],

    }).then(respuesta=>{
        if(respuesta){
            //  Condición para verificar si el valor del input es "ELIMINAR"
            if (input.value === "ELIMINAR") {
                swal({
                    title: `Registre amb id: ${id}`,
                    text: "S'ha eliminat correctament",
                    icon: "success",
                    button: "Acceptar",
                    timer: "3000"
                })
                postData(confirmacio);
            } else {
                swal("Error", "El text introduït no coincideix amb ELIMINAR", "error");
            }
        }
    });
}